import { render, staticRenderFns } from "./CardSectionGrid.vue?vue&type=template&id=5052bd4d"
import script from "./CardSectionGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardSectionGrid.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports